import React from 'react'

const SvgAgile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M9 5.5v-2l-4 3 4 3v-2c2.014 0 4 1.616 4 4s-1.986 4-4 4H2v2h7c2.986 0 6-2.384 6-6s-3.014-6-6-6z' />
    <path d='M2.881 10.583c.144-1.372.722-2.6 1.413-3.29l1.414 1.414c-.31.31-.732 1.082-.838 2.085a4.137 4.137 0 00.911 3.083l.508.635H3.783c-.786-1.363-1.03-2.708-.902-3.927zM17 12.5l5 4-5 4v-3h-4.5c2-1 2.5-2 2.5-2h2v-3z' />
  </svg>
)

export default SvgAgile
